import axios from 'axios';

// API endpoints configuration
const API_ENDPOINTS = {
  default: process.env.NODE_ENV === 'production' 
    ? 'https://chatbot-delta-bice-65.vercel.app/api' 
    : 'http://localhost:3003/api'
};

let currentEndpoint = API_ENDPOINTS.default;

// Create axios instance with base configuration
const createApiInstance = (baseURL) => {
  return axios.create({
    baseURL: baseURL,
    timeout: 900000, // 15 minutes timeout
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': 'chatbot-dev-key-2025'
    }
  });
};

let api = createApiInstance(currentEndpoint);

// Request interceptor
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('API Response Error:', {
      status: error.response?.status,
      message: error.response?.data?.error || error.message,
      url: error.config?.url
    });
    
    // Handle common errors
    if (error.response?.status === 500) {
      const errorMessage = error.response.data?.error || 'Server error occurred';
      throw new Error(errorMessage);
    }
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timeout - please try again');
    }
    
    if (!error.response) {
      throw new Error('Network error - please check your connection');
    }
    
    throw error;
  }
);

export const chatService = {
  // Send a message to the chatbot
  async sendMessage(message, conversationId = 'default', useBltzShield = false) {
    try {
      // Always use the backend for now, let backend handle Bltz Shield routing
      // Direct browser calls to Bltz Shield may have CORS issues
      const requestData = {
        message,
        conversationId,
        useBltzShield
      };
        
      const response = await api.post('/chat/message', requestData);
      return response.data;
    } catch (error) {
      console.error('Error sending message:', error);
      throw error;
    }
  },

  // Get conversation history
  async getConversationHistory(conversationId = 'default') {
    try {
      const response = await api.get(`/chat/conversations/${conversationId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching conversation history:', error);
      throw error;
    }
  },

  // Clear conversation history
  async clearConversation(conversationId = 'default') {
    try {
      const response = await api.delete(`/chat/conversations/${conversationId}`);
      return response.data;
    } catch (error) {
      console.error('Error clearing conversation:', error);
      throw error;
    }
  },

  // Get available models
  async getModels() {
    try {
      const response = await api.get('/chat/models');
      return response.data;
    } catch (error) {
      console.error('Error fetching models:', error);
      throw error;
    }
  },

  // Health check
  async checkHealth() {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      throw error;
    }
  },

  // Get current endpoint
  getCurrentEndpoint() {
    return currentEndpoint;
  }
};